// components/PasswordFieldWithPolicy.jsx
import React, { useMemo, useState } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { passwordPolicyCheck, checksToArray } from '../../../utils/passwordPolicy';

export default function PasswordFieldWithPolicy({
  value,
  onChange,
  label = 'Contraseña',
  name = 'password',
  fullName = '',
  email = '',
  errorText = '',
  confirmValue,
  onConfirmChange,
  confirmLabel = 'Confirmar contraseña',
  showConfirm = true,
  autoFocus = false,
}) {
  const [show, setShow] = useState(false);

  const { checks } = useMemo(() => passwordPolicyCheck(value || '', {
    nombreCompleto: fullName || '',
    correoInstitucional: email || '',
  }), [value, fullName, email]);

  const checklist = useMemo(() => checksToArray(checks), [checks]);

  return (
    <>
      <TextField
        autoFocus={autoFocus}
        margin="dense"
        name={name}
        label={label}
        type={show ? 'text' : 'password'}
        fullWidth
        variant="outlined"
        value={value}
        onChange={onChange}
        error={!!errorText}
        helperText={
          errorText ? errorText : (
            <div style={{ lineHeight: 1.25 }}>
              {checklist.map((c, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span
                    aria-hidden
                    style={{ color: c.ok ? '#2e7d32' /* success.main */ : '#d32f2f' /* error.main */ }}
                  >
                    {c.ok ? '✔︎' : '✗'}
                  </span>
                  <span style={{ opacity: c.ok ? 0.8 : 1 }}>{c.label}</span>
                </div>
              ))}
            </div>
          )
        }

        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShow(prev => !prev)} edge="end">
                {show ? <FaEyeSlash size={20}/> : <FaEye size={20}/>}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {showConfirm && typeof onConfirmChange === 'function' && (
        <TextField
          margin="dense"
          name="confirmPassword"
          label={confirmLabel}
          type={show ? 'text' : 'password'}
          fullWidth
          variant="outlined"
          value={confirmValue || ''}
          onChange={onConfirmChange}
        />
      )}
    </>
  );
}
